import { Button } from '~/components/ui/Button';
import { WrapperWidget, TrendBadge } from '@agentselly/ui';
import { Icon } from '~/components/Icon';
import { useTranslate } from '@tolgee/react';
import { AppLink } from '~/components/AppLink';

interface Props {
  readonly value?: number;
  readonly changeInLastWeek?: number;
  readonly title: string;
  readonly text: string;
  readonly numbers?: number[];
  readonly link?: string;
  readonly infoText?: string;
}

export function CockpitNumericValueWidget(props: Props) {
  const { t } = useTranslate();
  return (
    <WrapperWidget title={t(props.title)}>
      <div className="h-full flex flex-col gap-y-6">
        <div className="my-auto">
          <div className="flex items-center gap-x-6">
            {props.value !== null && props.value !== undefined ? (
              <span className="text-3xl font-bold tabular-nums">
                {props.value}
              </span>
            ) : (
              <div className="flex items-center gap-2">
                <Icon
                  icon="pieLineGraphDesktop"
                  className="w-5 h-5 text-gray-400"
                />
                <span className="text-lg text-gray-500 dark:text-gray-400">
                  {t('cockpit_numeric_no_data') || 'Keine Daten'}
                </span>
              </div>
            )}
            {props.changeInLastWeek !== null &&
            props.changeInLastWeek !== undefined &&
            props.changeInLastWeek !== 0 ? (
              <TrendBadge value={props.changeInLastWeek} />
            ) : null}
          </div>
        </div>

        {props.link ? (
          <AppLink
            to={props.link}
            className="self-start mxt-auto"
          >
            <Button
              primary
              showArrow
            >
              {t('cockpit_numerical_value_widget_button_text')}
            </Button>
          </AppLink>
        ) : (
          <Button className="invisible">
            _
            {/* this button is only here to ensure alignment of elements within widget doesn't depend on presence of props.link */}
          </Button>
        )}
      </div>
    </WrapperWidget>
  );
}
